module.exports = __webpack_public_path__ + "static/media/Mosammat.221a8266.jpg";